import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import FieldDisplay from "src/components/ProjectInstance/components/MainSection/FieldDisplay";
import EditableField from "src/components/ProjectInstance/components/MainSection/EditableField";
import EditableDateField from "./EditableDateField";
import { FORM_NAME } from "src/pages/TestPackage/detail";
import { PATTERN_ALPHANUMERIC_ID } from "src/constant/common";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const MainSection = ({ errors, register, control, testPackageData, setValue, IsCurrentLinkedInstanceInUse }) => {
  const { t } = useTranslation("test-package", "common");

  const getLinkedInstance = (id, name) => {
    if (!id || !name) return "";
    return (
      <div className="d-flex align-items-center">
        <TooltipWrapper
          id="tooltip-main-section-linked-instance"
          tooltipText={`#${id} - ${name}`}
          tooltipClassName="max-width-by-px-300"
          checkOverflow={true}
        >
          <span className="d-block overflow-hidden text-truncate max-width-by-px-400">{`#${id} - ${name}`}</span>
        </TooltipWrapper>
      </div>
    );
  };

  return (
    <AccordionItem>
      <AccordionHeader targetId="1" className="mt-0 fw-bold">
        {t("detail.main_section")}
      </AccordionHeader>
      <AccordionBody accordionId="1">
        <EditableField
          className="w-75"
          label={t(`detail.id`)}
          fieldName={FORM_NAME.MAIN.ID}
          value={testPackageData?.[FORM_NAME.MAIN.ID]}
          register={register}
          setValue={setValue}
          errors={errors}
          placeholder={t("new.id_placeholder")}
          requiredMessage={t("new.id_required")}
          maxLength={120}
          maxLengthMessage={t("maxlength", { max_length: 120 })}
          pattern={{
            value: PATTERN_ALPHANUMERIC_ID,
            message: t(`pattern_alphanumeric_id`, { field_name: t("new.id"), max_length: 120 }),
          }}
          errorsRelative
          isAllowEdit
          disabled={IsCurrentLinkedInstanceInUse}
          tooltipText={IsCurrentLinkedInstanceInUse ? "linked_instance_in_use" : "edit"}
          translation="test-package"
        />

        <EditableField
          className="w-75"
          label={t(`detail.name`)}
          fieldName={FORM_NAME.MAIN.TITLE}
          value={testPackageData?.[FORM_NAME.MAIN.TITLE]}
          setValue={setValue}
          register={register}
          errors={errors}
          placeholder={t("new.name_placeholder")}
          requiredMessage={t("new.name_required")}
          maxLengthMessage={t("maxlength", { max_length: 255 })}
          isAllowEdit
          disabled={IsCurrentLinkedInstanceInUse}
          tooltipText={IsCurrentLinkedInstanceInUse ? "linked_instance_in_use" : "edit"}
          translation="test-package"
        />

        <FieldDisplay
          className="w-75"
          label={t(`detail.linked_instance`)}
          value={getLinkedInstance(
            testPackageData?.yamcs_package?.[FORM_NAME.MAIN.INCREMENT_ID],
            testPackageData?.yamcs_package?.[FORM_NAME.MAIN.NAME]
          )}
        />
        <FieldDisplay
          className="w-75"
          label={t(`detail.used_greengrass_image`)}
          value={testPackageData?.latest_deployment?.gg_component_version || ""}
        />
        <FieldDisplay className="w-75" label={t(`detail.updated_by`)} value={testPackageData?.user_updated_by?.name || ""} />

        <EditableDateField
          className="w-75"
          label={t(`detail.planned_start_date`)}
          fieldName={FORM_NAME.MAIN.PLAN_START_DATE}
          value={testPackageData?.[FORM_NAME.MAIN.PLAN_START_DATE]}
          setValue={setValue}
          control={control}
          errors={errors?.[FORM_NAME.MAIN.PLAN_START_DATE]?.message}
          minDate={new Date()}
          disabled={IsCurrentLinkedInstanceInUse}
          tooltipText={IsCurrentLinkedInstanceInUse ? "linked_instance_in_use" : "edit"}
          translation="test-package"
        />
      </AccordionBody>
    </AccordionItem>
  );
};

export default MainSection;
